import {
    get_center_of_neighborhood,
    get_ways_by_municipality,
    get_first_between_ways_by_main,
    get_second_between_streets,
    get_address_coordinate,
    get_main_and_first_coordinate,
    get_main_street_coordinate,
    get_full_address_by_coordinate
} from './src/geocoding.mjs'

export default {
    get_center_of_neighborhood,
    get_ways_by_municipality,
    get_first_between_ways_by_main,
    get_second_between_streets,
    get_address_coordinate,
    get_main_and_first_coordinate,
    get_main_street_coordinate,
    get_full_address_by_coordinate
}